// extracted by mini-css-extract-plugin
export default {"unauthorized":"_20csgfrmFSawsyEGDw4INB"};